export const aprilProposal = {
  slug: "guggenheim",
  clientName: "Guggenheim Securities",
  accessEnvKey: "VITE_PROPOSAL_APRIL_ACCESS_CODE",
  comedyuoLogo: "/comedyuo-logo-white.png",
  heroImage: "https://storage.googleapis.com/cuo-website/Best+Comedy+Shows+.jpg",
  heroImageAlt: "A packed crowd at a ComedyUO show",
  heroEyebrow: "Prepared for April · Guggenheim Securities",
  heroHeadline: "A private comedy night.",
  heroSubheadline:
    "A comedy show for 40–50 guests. Three comics, one emcee, a menu we curate, and a bar we handle.",
  intro:
    "The show is comedy. Off-limit topics get discussed with you before the lineup is set. ComedyUO handles the room, the food, and the bar: beer, wine, and cocktails.",
  show: [
    "Three comics",
    "One emcee",
    "40–50 guests",
    "A menu we curate",
    "Beer, wine, and cocktails",
  ],
  food: {
    title: "We curate a menu for you.",
    body: "We handle the bar: beer, wine, and cocktails. The menu is included in the price below.",
    images: [
      {
        src: "https://storage.googleapis.com/cuo-website/Screenshot%202026-10-27%20at%209.04.59%E2%80%AFPM.png",
        alt: "Food from a ComedyUO night",
      },
      {
        src: "https://storage.googleapis.com/cuo-website/Screenshot%202026-10-27%20at%209.05.48%E2%80%AFPM.png",
        alt: "Food from a ComedyUO night",
      },
    ],
  },
  venues: [
    {
      name: "13th Storey",
      price: "$8,500",
      neighborhood: "Midtown · 216 East 45th Street",
      note: "Recommended",
      body: "A private rooftop lounge on the 13th floor, near Grand Central. Indoor lounge and a terrace, set up for a hosted comedy evening.",
      image: "https://storage.googleapis.com/cuo-website/Rooms%20We've%20Fooled%20Magic%20Show.jpg",
      imageAlt: "ComedyUO at 13th Storey",
    },
    {
      name: "DCTV Firehouse",
      price: "$9,500",
      neighborhood: "Chinatown · 87 Lafayette Street",
      note: "",
      body: "A landmarked former firehouse. High ceilings, exposed brick, and a room that already feels like a performance space.",
      image: "https://upload.wikimedia.org/wikipedia/commons/c/cf/DCTV-DN-firehouse-800x600.jpg",
      imageAlt: "The DCTV firehouse on Lafayette Street",
    },
    {
      name: "Élan Flowers",
      price: "$8,300",
      neighborhood: "Tribeca · 1 Worth Street",
      note: "",
      body: "A beautiful designer flower shop. Guests are in the studio, surrounded by the arrangements, for a seated comedy night.",
      image:
        "https://d5a894zvit21j.cloudfront.net/layouts/elan/images/banners/our_story_slider_2026.jpeg",
      imageAlt: "Élan Flowers studio",
    },
    {
      name: "Loft 29",
      price: "$9,000",
      neighborhood: "Garment District · 208 West 30th Street",
      note: "",
      body: "A loft in Suite 801, a short walk from Penn Station. Flexible layout, with room for a seated show.",
      image:
        "https://static1.squarespace.com/static/50984670e4b0f629c2ae06a3/t/63f8107a092b106308a9520c/1677201541650/Loft%2B29_Main%2BSpace_2.jpeg",
      imageAlt: "The main room at Loft 29",
    },
    {
      name: "Scuba Network",
      price: "$9,500",
      neighborhood: "Flatiron · 43 West 21st Street",
      note: "",
      body: "The dive shop between Fifth and Sixth. Masks, fins, and a retail floor that feels nothing like a standard event space. A close room for a comedy night.",
      image:
        "https://storage.googleapis.com/cuo-website/Screenshot%202026-10-27%20at%205.56.10%E2%80%AFPM.png",
      imageAlt: "Scuba Network",
    },
  ],
  runOfShow: [
    {
      time: "7:00",
      title: "Cocktail hour",
      body: "Doors open. The menu goes out. Beer, wine, and cocktails are on the bar. Guests mingle and find seats.",
    },
    {
      time: "7:45",
      title: "The show",
      body: "Guests are seated. The bar stays open. Three comics and one emcee.",
    },
    {
      time: "9:00",
      title: "Wind down",
      body: "Drinks stay out. Guests mingle and head out, with room to let the night run longer.",
    },
  ],
  logos: [
    { src: "https://storage.googleapis.com/cuo-website/JP+Morgan+Logo+(1).png", alt: "J.P. Morgan", large: true },
    { src: "/images/private-events-BILT_Rewards_Logo.png", alt: "BILT" },
    { src: "/images/private-events-Polymarket.png", alt: "Polymarket" },
    { src: "https://storage.googleapis.com/cuo-website/Akin+Gump+Logo.jpg", alt: "Akin Gump" },
    { src: "/images/private-events-Proskauer_Rose_Logo.png", alt: "Proskauer" },
    { src: "/images/private-events-Skadden_Arps_Logo.png", alt: "Skadden" },
    { src: "/images/private-events-Norton_Rose_Fulbright_Logo.png", alt: "Norton Rose Fulbright" },
  ],
  stories: [
    {
      title: "J.P. Morgan summer analysts",
      body: "A comedy night for summer analysts and partners. They gave us the topics to leave alone, and the lineup stayed clean.",
    },
    {
      title: "BILT",
      body: "We produce a neighborhood comedy series for BILT's users each month. Lineups are clean, and we activate upscale restaurants.",
    },
    {
      title: "Weil",
      body: "Weil wanted something specific for their LGBTQ affinity group. We produced a comedy show at the Stonewall Inn with an all queer lineup.",
    },
    {
      title: "Akin Gump",
      body: "A comedy show in an upscale restaurant. Akin Gump sent a list of topics to avoid. We booked a clean lineup, including a former Fried Frank lawyer who now tours.",
    },
    {
      title: "Proskauer",
      body: "Partners and clients, a Midtown speakeasy, and four mentalists. A different format than this comedy night, and the same care with the room.",
    },
  ],
  contactName: "Mike Zbyszewski",
  contactRole: "Sales & Partnerships, ComedyUO",
  contactEmail: "mike@comedyuo.com",
  contactPhone: "(310) 469-8961",
} as const;
